import { SvgIcon } from "@mui/material"

import { ReactComponent as Icon } from "./statut-black.svg"

export const StatusIcon = (props) => {
    return (
        <SvgIcon component={Icon} {...props} inheritViewBox />
    )
}